import { render, staticRenderFns } from "./BulkEditStatus.vue?vue&type=template&id=41af630a"
import script from "./BulkEditStatus.vue?vue&type=script&lang=js"
export * from "./BulkEditStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports